import { render, staticRenderFns } from "./StructureCompany.vue?vue&type=template&id=b7d7a45c&scoped=true&"
import script from "./StructureCompany.vue?vue&type=script&lang=js&"
export * from "./StructureCompany.vue?vue&type=script&lang=js&"
import style0 from "./StructureCompany.vue?vue&type=style&index=0&id=b7d7a45c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d7a45c",
  null
  
)

export default component.exports